let addDot = function (tinymce) {
  (function () {
    'use strict'
    let global = tinymce.util.Tools.resolve('tinymce.PluginManager')

    let doAddDot = function (editor) {
      let content = editor.selection.getContent()
      // if (/<span class="dot">(.*?)<\/span>/g.test(content)) {
      //   content = content.replace(/<span class="dot">(.*?)<\/span>/g, "$1");
      //   let placeholder = document.createElement('div');
      //   placeholder.innerHTML = content;
      //   let nodes = placeholder.childNodes;
      //   editor.selection.setNode(nodes)
      //   return;
      // }
      // 先清理dot，然后一起加dot
      content = content.replace(/<bdo class="dot">(.*?)<\/bdo>/g, "$1");
      const kMarkupPattern = /<!--[\s\S]*?-->|<(\/?)([a-zA-Z][-.:0-9_a-zA-Z]*)((?:\s+[^>]*?(?:(?:'[^']*')|(?:"[^"]*"))?)*)\s*(\/?)>/g;
      let insertText = '';
      let lastTextPos = 0;
      let match = [];

      while ((match = kMarkupPattern.exec(content))) {
        let { 0: matchText, 1: leadingSlash, 2: tagName, 3: attributes, 4: closingSlash } = match;

        const matchLength = matchText.length;
        const tagStartPos = kMarkupPattern.lastIndex - matchLength;
        const tagEndPos = kMarkupPattern.lastIndex;

        if (lastTextPos + matchLength < tagEndPos) {
          let text = content.substring(lastTextPos, tagStartPos);
          text = text.replace(/&nbsp;/g, '#')
          for (let index = 0; index < text.length; index++) {
            const element = text[index];
            if (!element || element === ' ' || element === '#') {
              insertText += element;
            }
            else {
              insertText += '<bdo class="dot">' + element + '</bdo>'
            }
          }
          insertText = insertText.replace(/#/g, '&nbsp;')
        }
        insertText += matchText;

        lastTextPos = tagEndPos;
      }

      if (!kMarkupPattern.test(content)) {
        for (let index = 0; index < content.length; index++) {
          const element = content[index];
          insertText += '<bdo class="dot">' + element + '</bdo>'
        }
      }

      let placeholder = document.createElement('div');
      placeholder.innerHTML = insertText;
      let nodes = placeholder.childNodes;
      editor.selection.setNode(nodes)
    }

    let register = function (editor) {
      editor.addCommand('doAddDot', function () {
        doAddDot(editor)
      })

      editor.addButton('addDot', {
        tooltip: '添加标注点',
        image: 'https://jty-open-new.obs.cn-north-4.myhuaweicloud.com/2024/2024-9-9/1725870517535ys0rtjt89o.png',
        icon: false,
        cmd: 'doAddDot'
      })

      editor.addMenuItem('addDot', {
        text: '添加标注点',
        image: 'https://jty-open-new.obs.cn-north-4.myhuaweicloud.com/2024/2024-9-9/1725870517535ys0rtjt89o.png',
        icon: false,
        cmd: 'doAddDot'
      })
    }

    global.add('addDot', function (editor) {
      register(editor)
    })

    function Plugin () {}

    return Plugin
  })()
}

export default addDot



// WEBPACK FOOTER //
// ./src/components/editor4/tinymce/plugins/addDot/index.js